/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_Project_Placeholder_DescriptionInputs */



/**
* | output |
* | --- |
* | "Brief description of your project..." |
*
* @param {Create_Project_Placeholder_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const create_project_placeholder_description = /** @type {((inputs?: Create_Project_Placeholder_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_Project_Placeholder_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kurze Beschreibung deines Projekts...")
	return /** @type {LocalizedString} */ ("Brief description of your project...")
});